import { Injectable } from '@angular/core';
import { SwUpdate, UpdateAvailableEvent } from '@angular/service-worker';
import { Observable } from 'rxjs';

@Injectable()
export class UpdateService {
  updates: SwUpdate;
  isUpdateDelayed: boolean = false;

  constructor(updates: SwUpdate) {
    this.updates = updates;
  }

  getAvailable(): Observable<UpdateAvailableEvent> {
    return this.updates.available;
  }

  setIsUpdateDelayed(value: boolean) {
    this.isUpdateDelayed = value;
  }
}
